import { cn } from "@/lib/cn";

export interface MeterProps {
  /** 0-100 */
  value: number;
  label?: string;
  className?: string;
}

/** 原型基元：`.meter`（宽度直接落在内层 span 上，与原型的行内样式写法一致）。 */
export function Meter({ value, label, className }: MeterProps) {
  return (
    <div
      className={cn("meter", className)}
      role="meter"
      aria-valuenow={Math.round(value)}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-label={label}
    >
      <span style={{ width: `${Math.max(0, Math.min(100, value))}%` }} />
    </div>
  );
}

export interface ProgressRowProps {
  label: React.ReactNode;
  value: number;
  /** 覆盖进度条颜色时传入 CSS 颜色值（令牌或字面量）。 */
  barColor?: string;
  sublabel?: string;
}

/** 原型基元：`.progress-row`（app.js `progressRow` / `anchorProgress`）。 */
export function ProgressRow({ label, value, barColor, sublabel }: ProgressRowProps) {
  return (
    <div className="progress-row">
      <span>
        {sublabel ? <strong>{label}</strong> : label}
        {sublabel ? (
          <small
            style={{
              display: "block",
              color: "var(--ink-faint)",
              fontSize: "9px",
              marginTop: "3px",
            }}
          >
            {sublabel}
          </small>
        ) : null}
      </span>
      <div className="progress-track">
        <span style={{ width: `${value}%`, ...(barColor ? { background: barColor } : {}) }} />
      </div>
      <strong>{value}%</strong>
    </div>
  );
}

export interface SkillRowProps {
  label: string;
  value: number;
}

/** 原型基元：`.skill-row`（编剧成长 · 能力画像）。 */
export function SkillRow({ label, value }: SkillRowProps) {
  return (
    <div className="skill-row">
      <span>{label}</span>
      <div className="progress-track">
        <span style={{ width: `${value}%` }} />
      </div>
      <strong>{value}</strong>
    </div>
  );
}
